export default __webpack_public_path__ + "src/assets/icn-running.9683ca5ed29c60f38ffcb6bbbe8d269b.svg";